<template>
  <div class="home">
    <div>
      <h1 class="display-3">Welcome <font color="#af0f6a">{{ user.username }}</font> </h1>
      <p class="lead">This is the home page of Romeflex Market Platform</p>
    </div>
  </div>
</template>

<style>
  .home {
    height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #fdc631;
  }
  .home .lead {
    font-weight: 200;
    font-size: 1.5rem;
    color: #e6197e;
  }
</style>

<script>
export default {
  name: 'home',
  data () {
    return {
      user: this.$session.get('user')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue